import { call, takeEvery, select } from 'redux-saga/effects';
import {
  SELECT_ELEMENT_CURSOR_CATEGORY,
  SELECT_ELEMENT_CURSOR_SUBCATEGORY,
  SET_ELEMENT_CURSOR
} from 'JS/actionCreators/cursorActions';

import { track } from '../mixpanelProvider';
import { getScribeById } from '../../selectors';

function* trackElementCursorCategorySelection({ scribeId, elementIds, cursorCategory }) {
  const activeScribe = yield select(state => getScribeById(state, scribeId));

  yield call(track, 'Select Element Cursor Category', {
    'Cursor Category': cursorCategory,
    'Element Type':
      elementIds.length === 1 ? activeScribe.elements.find(element => element.id === elementIds[0]).type : 'Multiple',
    'Scribe ID': scribeId,
    'Number of Elements': elementIds.length
  });
}

function* trackElementCursorSubCategorySelection({ scribeId, elementIds, cursorSubCategory }) {
  const activeScribe = yield select(state => getScribeById(state, scribeId));

  yield call(track, 'Select Element Cursor Sub Category', {
    'Cursor Category': cursorSubCategory,
    'Element Type':
      elementIds.length === 1 ? activeScribe.elements.find(element => element.id === elementIds[0]).type : 'Multiple',
    'Scribe ID': scribeId,
    'Number of Elements': elementIds.length
  });
}

function* trackElementCursorSelection({ scribeId, elementIds, cursorId }) {
  const activeScribe = yield select(state => getScribeById(state, scribeId));
  const cursor = yield select(state => state.scribes.cursors.find(cursor => cursor.id === cursorId));

  yield call(track, 'Select Element Cursor', {
    'Cursor Category': cursor ? cursor.group : 'No Cursor',
    'Cursor Name': cursor ? cursor.name : 'No Cursor',
    'Element Type':
      elementIds.length === 1 ? activeScribe.elements.find(element => element.id === elementIds[0]).type : 'Multiple',
    'Scribe ID': scribeId,
    'Number of Elements': elementIds.length
  });
}

export default function* trackElementCursorSelectionSagas() {
  yield takeEvery(SELECT_ELEMENT_CURSOR_CATEGORY, trackElementCursorCategorySelection);
  yield takeEvery(SELECT_ELEMENT_CURSOR_SUBCATEGORY, trackElementCursorSubCategorySelection);
  yield takeEvery(SET_ELEMENT_CURSOR, trackElementCursorSelection);
}
